import * as React from 'react'
import { DisturberProps } from './types'
import { Button } from '../../components/UI/Button'
import {
  StyledBody,
  StyledBodyMain,
  StyledButtons,
  StyledDescription,
  StyledDisturber,
  StyledDisturberFeatureImage,
  StyledFeatureList,
  StyledFeatureListItem,
  StyledHeadline,
  StyledImage,
  StyledText,
  StyledWrapper,
} from './styled'
import { useI18n } from '../../lib/context/i18n'
import CustomLink from '../../components/CustomLink'
import { sbEditable } from '@storyblok/storyblok-editable'

export const Disturber = ({ blok }: DisturberProps) => {
  const disturberProps = { size: blok.size }
  const bodyProps = { image: blok.image }
  const headlineProps = { size: blok.size }
  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <StyledWrapper className={blok.theme && `theme-${blok.theme}`} {...sbEditable(blok)}>
      <StyledDisturber {...disturberProps}>
        <StyledBody {...bodyProps}>
          <StyledBodyMain {...bodyProps}>
            {blok.image.filename && (
              <StyledImage>
                <img src={blok.image.filename} alt={blok.image.alt || blok.image.name || blok.title} />
              </StyledImage>
            )}
            <StyledText>
              {blok.title && <StyledHeadline {...headlineProps} fontSize={blok.titleFontSize}>{blok.title}</StyledHeadline>}
              {blok.description && <StyledDescription fontSize={blok.descriptionFontSize}> {blok.description}</StyledDescription>}
            </StyledText>
          </StyledBodyMain>
          {blok.buttons && (
            <StyledButtons {...bodyProps}>
              {blok.buttons?.map((button, i) => {
                return (
                  <Button
                    key={i}
                    as={CustomLink}
                    to={
                      button.product_code
                        ? `${getTranslatedUrlFromLink(button.link)}?product_code=${button.product_code}`
                        : getTranslatedUrlFromLink(button.link)
                    }
                    $variant={button.button_style}
                    title={button.link_title}
                    $inverted

                  >
                    {button.button_name}
                  </Button>
                )
              })}
            </StyledButtons>
          )}
        </StyledBody>
        {blok.disturberFeatureList?.length > 0 && (
          <StyledFeatureList>
            {blok.disturberFeatureList?.map(disturberFeature => {
              return (
                <StyledFeatureListItem key={disturberFeature._uid}>
                  <StyledDisturberFeatureImage>
                    <img
                      src={disturberFeature.image.filename}
                      alt={disturberFeature.image?.alt || disturberFeature.image?.name || disturberFeature.label}
                    />
                  </StyledDisturberFeatureImage>
                  <span>{disturberFeature.label}</span>
                </StyledFeatureListItem>
              )
            })}
          </StyledFeatureList>
        )}
      </StyledDisturber>
    </StyledWrapper >
  )
}
